import universal from 'react-universal-component'

export const TransientPlayground= universal(props => import('./TransientRoot'))

export default TransientPlayground